const Footer = () => {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Tiryaq. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
